enum WorkspaceProjectLandAgreementStatus {
  'Draft' = 'Draft',
  'Published' = 'Published',
}

export default WorkspaceProjectLandAgreementStatus
